<template>
  <a href="#main-content"
     class="bx-content__continuous-text bx-typo--content-continuous-text bx-header__skip-link">
    Zum Hauptinhalt springen
  </a>
</template>
